export const removeUnderscore = (text) => {
    if (typeof text !== 'string') return text;  
    return text.replace(/_/g, ' ');  
  };
  